import { render, staticRenderFns } from "./iOSPlayer.vue?vue&type=template&id=5f08e562&"
import script from "./iOSPlayer.vue?vue&type=script&lang=js&"
export * from "./iOSPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports